module.exports = __webpack_public_path__ + "static/media/aboutcoating.0a5de8f4.png";